import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';

export default function VariableTab({ font, previewText }) {
  const { theme } = useTheme();
  const axes = font.variable_axes ? (typeof font.variable_axes === 'string' ? JSON.parse(font.variable_axes) : font.variable_axes) : [];
  const [values, setValues] = useState(() => {
    const init = {};
    for (const axis of axes) {
      init[axis.tag] = axis.default ?? axis.min;
    }
    return init;
  });

  if (!font.is_variable || axes.length === 0) {
    return <div style={{ color: theme.textMuted, fontSize: 12, padding: 20 }}>This is not a variable font</div>;
  }

  const variationSettings = Object.entries(values)
    .map(([tag, val]) => `"${tag}" ${val}`)
    .join(', ');

  return (
    <div>
      {/* Preview */}
      <div style={{
        border: `1px solid ${theme.border}`, padding: 16, marginBottom: 16,
      }}>
        <div style={{
          fontFamily: `'${font.family}', serif`,
          fontSize: 28, color: theme.text, lineHeight: 1.3,
          fontVariationSettings: variationSettings,
        }}>
          {previewText || 'The quick brown fox jumps over the lazy dog'}
        </div>
      </div>

      {/* Axis sliders */}
      <div style={{ fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase', color: theme.textFaint, marginBottom: 8 }}>
        {axes.length} variable {axes.length === 1 ? 'axis' : 'axes'}
      </div>
      {axes.map(axis => (
        <div key={axis.tag} style={{ marginBottom: 12 }}>
          <div style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            marginBottom: 4,
          }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: theme.textSecondary }}>
              {axis.name || axis.tag}
            </span>
            <span style={{ fontSize: 11, color: theme.textMuted, fontVariantNumeric: 'tabular-nums' }}>
              {values[axis.tag]?.toFixed?.(0) ?? values[axis.tag]}
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 9, color: theme.textGhost }}>{axis.min}</span>
            <input
              type="range"
              min={axis.min}
              max={axis.max}
              step={(axis.max - axis.min) > 10 ? 1 : 0.1}
              value={values[axis.tag] ?? axis.default}
              onChange={e => setValues(prev => ({ ...prev, [axis.tag]: parseFloat(e.target.value) }))}
              style={{ flex: 1, accentColor: theme.accent }}
            />
            <span style={{ fontSize: 9, color: theme.textGhost }}>{axis.max}</span>
          </div>
        </div>
      ))}

      {/* Reset button */}
      <button
        onClick={() => {
          const reset = {};
          for (const axis of axes) reset[axis.tag] = axis.default ?? axis.min;
          setValues(reset);
        }}
        style={{
          marginTop: 8, padding: '6px 12px', fontSize: 12, textTransform: 'lowercase',
          background: 'none', border: `1px solid ${theme.borderMedium}`,
          borderRadius: 0, color: theme.textSecondary, cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >reset to defaults</button>
    </div>
  );
}
